import React from "react";
import { useTranslation } from "react-i18next";

export function LocationSearchResultsTable({ locations, onSelectLocation }) {

    const { t } = useTranslation();

    const formatBoolean = (value) =>
        value ? t("global_yes") : t("global_no");

    const formatInvitations = (location) => {
        if (location.invitationsTotal == null)
            return "-";
        return `${location.invitationsAvailable ?? "-"} / ${location.invitationsTotal}`;
    };

    return (
        <div className="table-responsive">
            <table className="table table-hover">
                <thead>
                    <tr>
                        <th>{t("global_location")}</th>
                        <th>{t("mod_device_search_admin_email")}</th>
                        <th>{t("mod_location_search_premium")}</th>
                        <th>{t("mod_location_search_licenses")}</th>
                        <th>{t("mod_location_search_users")}</th>
                        <th>{t("mod_location_search_invitations")}</th>
                    </tr>
                </thead>
                <tbody>
                    {locations.map(location => (
                        <tr
                            key={location.locationId}
                            style={onSelectLocation ? { cursor: "pointer" } : undefined}
                            onClick={() => onSelectLocation?.(location)}
                        >
                            <td>{`${location.locationName ?? "-"} (${location.locationId ?? "-"})`}</td>
                            <td>{location.adminEmail || "-"}</td>
                            <td>{formatBoolean(location.hasPremiumPlan)}</td>
                            <td>
                                <div className="d-flex flex-wrap">
                                    {location.activeLicenseNames.map(name => (
                                        <span key={name} className="badge badge-secondary mr-1 mb-1">
                                            {name}
                                        </span>
                                    ))}
                                </div>
                            </td>
                            <td>{location.numUsers ?? "-"}</td>
                            <td>{formatInvitations(location)}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
}
